const PaginatorFactory = function () {
    let activePageNumber = 0;
    let pagesCount = 0;
    let dataReady = false;

    const getActivePageNumber = () => {
        return activePageNumber;
    }

    const setActivePageNumber = (pageNumber) => {
        activePageNumber = pageNumber;
    }

    const getPagesCount = () => {
        return pagesCount;
    }

    const setPagesCount = (pgCount) => {
        pagesCount = pgCount;
    }

    const getDataReady = () => {
        return dataReady;
    }

    const setDataReady = (dtReady, pgCount, pageNumber) => {
        dataReady = dtReady;
        pagesCount = pgCount;
        activePageNumber = pageNumber;
    }

    return {
        getActivePageNumber,
        setActivePageNumber,
        getPagesCount,
        setPagesCount,
        getDataReady,
        setDataReady
    }
}

export default PaginatorFactory;



// WEBPACK FOOTER //
// ./client/app/components/home/book/step3/paginator/paginator.factory.js